<template>
    <div class="pa-5">
        <div
            v-for="classificator in productClassificators"
            v-if="
                classificator.assigned_tab === 'specification' &&
                    activeProduct.data[classificator.classificator_type] &&
                    hasRowValueAndValueIsNotNullOrEmpty(activeProduct.data[classificator.classificator_type])
            "
        >
            <div>
                <strong>{{ getClassificatorOrClassificatorRowTitle(classificator.title) }}</strong>
            </div>
            <div v-for="cr in classificator.rows">
                <v-row v-if="cr.value_type === 'text' || cr.value_type === 'number'">
                    <v-col class="row-title col-item" cols="5">{{
                        getClassificatorOrClassificatorRowTitle(cr.title)
                    }}</v-col>
                    <v-col class="col-item" cols="6">
                        {{ getRowValue(cr.id, classificator.classificator_type) }}
                    </v-col>
                </v-row>
                <v-row
                    v-else-if="
                        cr.value_type === 'boolean' && getRowValue(cr.id, classificator.classificator_type) === true
                    "
                >
                    <v-col class="row-title col-item" cols="5">{{
                        getClassificatorOrClassificatorRowTitle(cr.title)
                    }}</v-col>
                    <v-col class="col-item" cols="6">
                        <v-icon style="font-size: 20px">
                            fal fa-check
                        </v-icon>
                    </v-col>
                </v-row>
                <v-row v-else-if="cr.value_type === 'text_field'">
                    <v-col cols="12">
                        {{ getRowValue(cr.id, classificator.classificator_type) }}
                    </v-col>
                </v-row>
                <v-row v-else-if="cr.value_type === 'tiptap_editor'">
                    <v-col cols="12">
                        <span v-html="getRowValue(cr.id, classificator.classificator_type)"></span>
                    </v-col>
                </v-row>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";
import ClassificatorInput from "../../../components/classificator-input.vue";
import { userTranslationFunctions } from "../../../mixins/user-translation-functions";
export default {
    name: "specification-tab",
    components: {},
    mixins: [userTranslationFunctions],
    data() {
        return {
            data: {}
        };
    },
    mounted() {},
    computed: {
        ...mapState("ProductStore", ["activeProduct", "productClassificators"])
    },
    methods: {
        getRowValue(cr_id, type) {
            if (this.activeProduct.data && this.activeProduct.data[type]) {
                const classificatorItemData = this.activeProduct.data[type].find(p => p.classificator_row_id === cr_id);
                if (classificatorItemData) return classificatorItemData.value;
            }
            return "-";
        },
        hasRowValueAndValueIsNotNullOrEmpty(classificator) {
            let hasCorrectValue = false;
            classificator.map(classificatorClass => {
                const c = JSON.parse(JSON.stringify(classificatorClass));
                if (c.value !== null && c.value !== "" && c.value !== false) {
                    hasCorrectValue = true;
                    return hasCorrectValue;
                }
            });
            return hasCorrectValue;
        }
    }
};
</script>

<style scoped>
.row-title {
    color: gray;
}
.col-item {
    padding-top: 2px;
    padding-bottom: 2px;
}
</style>
